import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import "./styles/theme.css";
import "./index.css";
import "./styles/lawAfricaBrand.css";

const rootEl = document.getElementById("root");

if (!rootEl) {
  throw new Error("Root element #root not found.");
}

const Wrapper = import.meta.env.DEV ? React.StrictMode : React.Fragment;

ReactDOM.createRoot(rootEl).render(
  <Wrapper>
    <App />
  </Wrapper>
);
